import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <ul className="greenbullet-list ">

                                                    <li><span
                                                        className="subtiltereg">Explore the implications</span>
                                                        <br/>Investigating the wider effects or implications of
                                                        an issue can help raise awareness of its overall
                                                        impact.
                                                    </li>
                                                    <li><span className="subtiltereg">Recognise feelings</span>
                                                        <br/>Recognising the possible emotional aspect of a
                                                        situation may take the dialogue to a different
                                                        level. It may not otherwise be immediately apparent
                                                        that emotional support is required.
                                                    </li>
                                                    <div>
                                                        <li className="textbottompadding"><span
                                                            className="subtiltereg ">Make a clear statement</span>
                                                            <br/>Making your expectation absolutely clear ensures
                                                            that there is no ambiguity.
                                                        </li>
                                                    </div>

                                                </ul>
                                            </div>
                                            <p>Consider how this model is used to good effect in the following
                                                example of feedback:</p>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">Acknowledging</div>
                                                <p>the other person’s position:</p>
                                            </div>
                                            <p>‘I can see you feel you have been unfairly treated’</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">ASKING the other person’s views
                                                    and LISTENING and accepting that this
                                                    is how they see it, even if you disagree with what they say:
                                                </div>
                                            </div>
                                            <p>‘How do you see…?’ ‘Do you agree with…?’</p>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">Describing</div>
                                                <p>factually, the specific situation you are unhappy about:</p>
                                            </div>
                                            <p>‘You have been delivering the reports two or three weeks late,
                                                for four months, and…’</p>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">Effects</div>
                                                <p>describing factually the effects of the actions with which
                                                    you are dissatisfied:</p>
                                            </div>
                                            <p>‘…and the effects are that the budget figures are two or three
                                                weeks late, which means that…’</p>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">Feelings</div>
                                                <p>stating your feelings, reactions and opinions resulting from
                                                    the other person’s actions:</p>
                                            </div>
                                            <p>‘I get annoyed when…’ ‘I’m not satisfied with…’ </p>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <div className="border_subtitle">Provide A CLEAR STATEMENT of
                                                    what you want to change and how:
                                                </div>

                                            </div>
                                            <p>‘What I want is….’</p>
                                            <div className="border_subtitle">Summary</div>
                                            <p>It is important to get the balance right between support and
                                                challenge in order to help others grow and improve. Remember
                                                that to challenge someone is not necessarily negative but can be
                                                about pushing them to improve or change. Coupled with the right
                                                type of support it can make the difference between boredom or
                                                stress and peak performance.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page6')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}